import React from "react";
import classes from "./TitleFromTooltip.module.scss";
import { isValidHttpUrl } from "../../../utils/helpers/regex.helpers";

interface ITitleFromTooltip {
  title?: string | JSX.Element;
  labelInfo?: string | JSX.Element;
  value?: string | number;
  customStyle?: React.CSSProperties;
  isLink?: boolean;
  isMask?: boolean;
  maskPlaceholder?: string;
}

const TitleFromTooltip: React.FC<ITitleFromTooltip> = ({
  isLink,
  title = "",
  labelInfo = "",
  value = "",
  customStyle = {},
  isMask = false,
  maskPlaceholder = "_",
}) => {
  const currentValue =
    isMask && typeof value === "string"
      ? value.replaceAll(maskPlaceholder, "") && value
      : value;
  return title || value ? (
    <div className={classes.content} style={customStyle}>
      <p className={classes["content__title"]}>
        {isLink && isValidHttpUrl(value as string) && value ? (
          <a
            className={classes["content__link"]}
            href={value as string}
            target="_blank"
            rel="noreferrer"
          >
            {title}
          </a>
        ) : (
          title
        )}
        {labelInfo}
      </p>
      {!isLink && (
        <span className={classes["content__description"]}>{currentValue}</span>
      )}
    </div>
  ) : null;
};

export default TitleFromTooltip;
